module.exports = __webpack_public_path__ + "img/toTopNew.362d6f85.png";